module.exports = {
      id: "android-block-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#android-block",
      toString: function () {
        return this.url;
      }
    }